import React, { createContext, useState, useContext, useEffect } from "react";
import SuccessNotification from "../components/SuccessNotification";

const NotificationContext = createContext();

export const NotificationProvider = ({ children, socket }) => {  // ✅ WebSocket reçu en prop
  const [notifications, setNotifications] = useState([]);

  const notify = (title, description) => {
    const id = Date.now();
    setNotifications([...notifications, { id, title, description }]);

    setTimeout(() => {
      setNotifications((current) => current.filter((notif) => notif.id !== id));
    }, 5000);
  };

  // ✅ Ajoute un listener pour les messages WebSocket
  useEffect(() => {
    if (!socket) return;

    socket.onmessage = (event) => {
      const data = JSON.parse(event.data);
      console.log("📩 Notification WebSocket reçue :", data);
      if (data.type === "notification") {
        notify(data.notification.message, data.notification.description);
      }
    };
  }, [socket]);

  return (
    <NotificationContext.Provider value={{ notify }}>
      {children}
      <div>
        {notifications.map((notif) => (
          <SuccessNotification
            key={notif.id}
            title={notif.title}
            description={notif.description}
            onClose={() =>
              setNotifications((current) => current.filter((n) => n.id !== notif.id))
            }
          />
        ))}
      </div>
    </NotificationContext.Provider>
  );
};

export const useNotification = () => useContext(NotificationContext);
